<template>
  <div class="commit-hash-input-wrapper">
    <b-input-group :prepend="label" class="mt-3">
      <b-form-input
        :value="value"
        @input="onInput"
        @focus="onFocus"
        @blur="onBlur"
        :placeholder="placeholder"
        maxlength="40"
        :disabled="disabled"
        :state="validationState"
        autocomplete="off"
      />
    </b-input-group>
    <div
      v-if="showDropdown && branches.length > 0"
      :class="dropdownClasses"
    >
      <div
        v-for="branch in branches"
        :key="branch.name"
        class="autocomplete-item"
        @click="onBranchClick(branch)"
      >
        {{ branch.name }}
        <span v-if="branch.latestCommit" class="commit-hash-preview">
          {{ branch.latestCommit.slice(0, 8) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommitHashInput',
  props: {
    value: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: 'Enter commit hash',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    validationState: {
      type: [Boolean, null],
      default: null,
    },
    branches: {
      type: Array,
      default: () => [],
    },
    position: {
      type: String,
      default: 'left',
    },
  },
  data() {
    return {
      showDropdown: false,
    };
  },
  computed: {
    dropdownClasses() {
      return [
        'autocomplete-dropdown-commit-info',
        this.position === 'right' ? 'autocomplete-dropdown-commit-right' : 'autocomplete-dropdown-commit-left',
      ];
    },
  },
  methods: {
    onFocus() {
      if (this.branches.length > 0) {
        this.showDropdown = true;
      }
    },
    onBlur() {
      setTimeout(() => {
        this.showDropdown = false;
      }, 100);
    },
    onBranchClick(branch) {
      this.$emit('input', branch.latestCommit);
      this.showDropdown = false;
    },
    onInput(event) {
      setTimeout(() => {
        this.$emit('input', event);
        this.showDropdown = false;
      }, 100);
    },
  },
};
</script>

<style scoped>
.commit-hash-input-wrapper {
  position: relative;
  flex: 1;
}

.autocomplete-dropdown-commit-info {
  position: absolute;
  z-index: 1000;
  background-color: white;
  border: 1px solid #bdd5ee;
  border-radius: 0.375rem;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  margin-top: -1rem;
}

.autocomplete-dropdown-commit-left {
  left: 0;
}

.autocomplete-dropdown-commit-right {
  right: 0;
}

.autocomplete-item {
  padding: 0.5rem 1rem;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.autocomplete-item:hover {
  background-color: #f1f5f9;
}

.autocomplete-item:last-child {
  border-bottom-left-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}

.commit-hash-preview {
  color: #6b7280;
  font-family: monospace;
  font-size: 0.875rem;
}
</style>
